<template>
  <DropdownBase>
    <template #trigger>
      <BaseIconButton :icon="icon" :title :size data-testid="context-menu-trigger" class="w-full" />
    </template>
    <template #content>
      <slot />
    </template>
  </DropdownBase>
</template>

<script>
import DropdownBase from "./DropdownBase";

export default {
  components: {
    DropdownBase,
  },

  props: {
    size: {
      type: String,
      default: "md",
      validator(value) {
        return ["xs", "sm", "md"].includes(value);
      },
    },

    title: {
      type: String,
      default: null,
    },

    icon: {
      type: String,
      default: "ellipsis-vertical",
    },
  },
};
</script>
